import React from "react";
import Culture1 from "../../img/ico-4_a.png";
import Culture2 from "../../img/ico-4_b.png";
import Culture3 from "../../img/ico-4_ca.png";
import Culture4 from "../../img/ico-4_cb.png";
import Culture5 from "../../img/ico-4_cc.png";
import Culture6 from "../../img/ico-4_cd.png";


function Culture() {


  return (
    <section className="text-[#244566] text-center bg-[#e9eef4] flex flex-col justify-center items-center space-y-14 pt-6 pb-14">
      <h3 className="text-2xl font-semibold px-3">OUR CULTURE AND BENEFITS</h3>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 w-[90%] xl:w-[60%]">
        <div className="card-career">
          <img alt="" src={Culture1} className="w-[70px] h-[70px]" />
          <h4 className="text-career">FLEXIBLE WORK ARRANGEMENT</h4>
          <p className="pb-2">Flexible work schedule that suits your lifestyle</p>       
        </div>
        <div className="card-career">
          <img alt="" src={Culture2} className="w-[70px] h-[70px]" />
          <h4 className="text-career">INCLUSIVE CULTURE</h4>
          <p className="pb-2">A positive work environment that encourages and celebrates diverse perspectives</p>       
        </div>
        <div className="card-career">
          <img alt="" src={Culture3} className="w-[70px] h-[70px]" />
          <h4 className="text-career">PROFESSIONAL DEVELOPMENT</h4>
          <p className="pb-2">Limitless opportunities to develop your leadership skills and reach your full potential</p>       
        </div>
        <div className="card-career">
          <img alt="" src={Culture4} className="w-[70px] h-[70px]" />
          <h4 className="text-career">MEANINGFUL RELATIONSHIPS</h4>
          <p className="pb-2">A platform to foster lasting connections with people you meet and work with</p>       
        </div>
        <div className="card-career">
          <img alt="" src={Culture5} className="w-[70px] h-[70px]" />
          <h4 className="text-career">COMMITMENT TO WORK COMMUNITY</h4>
          <p className="pb-2">An environment that values positive contribution for the collective betterment of the Group</p>       
        </div>
        <div className="card-career">
          <img alt="" src={Culture6} className="w-[70px] h-[70px]" />
          <h4 className="text-career">CAREER GROWTH</h4>
          <p className="pb-2">Abundant opportunities for professional growth and career advancement</p>       
        </div>
      </div>
    </section>
  );
}

export default Culture;
